export default __webpack_public_path__ + "static/media/lord-ayyappa.24d869cd.jpg";